var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpOnleave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00049 20.5H18.0005",
    stroke: "#252C32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82545 12.6661C3.55045 12.4661 3.30045 12.2161 3.00046 11.3411C2.91909 11.1241 2.61157 10.0362 2.35046 9.04109C2.13021 8.2017 1.93395 7.43555 2.02546 7.24109C2.10047 7.04109 2.20045 6.89109 2.52545 6.69109C2.72545 6.56802 3.75045 6.31609 3.95045 6.26609C4.15045 6.21609 4.42544 6.19109 4.65045 6.26609C5.07545 6.34109 5.95045 7.61609 6.17545 7.76609C6.27544 7.86609 6.60045 8.157 6.97545 8.19109C7.25045 8.21609 7.52545 8.14109 7.82546 8.01609C8.10045 7.90151 13.5255 5.26609 14.0255 5.04109C18.1005 3.34109 21.0605 6.13609 21.5105 6.73609C21.9755 7.31609 22.0755 7.49109 21.9505 7.99109C21.7889 8.51609 21.3505 8.61609 21.1005 8.69109C20.8505 8.76609 17.4005 9.69109 16.0505 10.0661C15.7556 10.1621 15.6116 10.3549 15.5755 10.3911C15.4005 10.6411 14.6055 12.3411 14.3805 12.7161C14.2255 13.1161 13.8005 13.6161 13.2505 13.8161C12.6755 14.0161 11.6755 14.2411 11.4505 14.3161C11.2255 14.3911 10.7005 14.5411 10.5255 14.4911C10.3005 14.4411 10.0855 14.2161 10.1855 13.8661C10.2855 13.5161 10.4755 12.5411 10.5005 12.3911C10.5255 12.2411 10.7755 11.6161 10.5005 11.5911C10.4505 11.5161 9.92545 11.7411 9.15045 11.9161C8.57467 12.0782 7.97168 12.2386 7.55045 12.3411C5.92545 12.8161 5.04539 12.9411 4.85045 12.9411C4.47545 12.9411 4.20045 12.8911 3.82545 12.6661Z",
    stroke: "#252C32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpOnleave);
export default __webpack_public_path__ + "static/media/emp-onleave.1ef0ea777c881046f6cc25ffab7e7c99.svg";
export { ForwardRef as ReactComponent };